import { useState } from "react";
import api from "../../api/ApiService";
import Button from "./Button";
import { API_BASE_URL } from "../../config/apiConfig";

const DownloadExcel = ({
  apiEndpoint,
  queryParams = {},
  buttonText = "Download Excel",
  className = "",
}) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);

      // Build query string from queryParams object
      const queryString = new URLSearchParams(queryParams).toString();
      const url = queryString ? `${apiEndpoint}?${queryString}` : apiEndpoint;

      // Request Excel generation
      const response = await api.post(url);

      if (response?.file) {
        // The file link is encrypted; open in a new tab
        const downloadUrl = `${API_BASE_URL}/download/${response.file}`;
        window.open(downloadUrl, "_blank");
      } else {
        console.error("No file returned from API");
      }
    } catch (error) {
      console.error("Failed to download Excel", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={handleDownload}
      disabled={loading}
      className={`bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm ${className}`}
    >
      {loading ? "Downloading..." : buttonText}
    </Button>
  );
};

export default DownloadExcel;
